import { useEffect, useState, useMemo } from "react";
import { useGetDocFieldsWithVisibilityQuery } from "../../store/api/globalapi";

const ConfigureColumns = ({ show, onClose, onSave, docType, defaultSelected = [] }) => {
  const [fields, setFields] = useState([]);
  const [selectedValues, setSelectedValues] = useState([]);


  const defaultSelectedKeys = useMemo(() => {
    return defaultSelected
      .map(col => col.accessor?.toLowerCase())
      .filter(Boolean);
  }, [defaultSelected]);

  const { data, isLoading, isError } = useGetDocFieldsWithVisibilityQuery(docType, {
    skip: !show,
  });

  useEffect(() => {
    if (data?.message) {
      const transformed = data.message
        .filter(field => field.fieldname && field.label)
        .map(field => {
          const fieldKey = field.fieldname.toLowerCase();
          return {
            name: field.label,
            key: field.fieldname,
            selected: defaultSelectedKeys.includes(fieldKey)
          };
        });

      setFields(transformed);
      setSelectedValues(
        transformed.filter(f => f.selected).map(f => f.key)
      );
    }
  }, [data, defaultSelectedKeys]);

  const toggleFieldSelection = (index) => {
    const newFields = [...fields];
    newFields[index].selected = !newFields[index].selected;
    setFields(newFields);

    const fieldKey = newFields[index].key;
    setSelectedValues(prev =>
      newFields[index].selected
        ? [...prev, fieldKey]
        : prev.filter(k => k !== fieldKey)
    );
  };

  const handleSave = () => {
    onSave(selectedValues);
    onClose();
  };

  if (!show) return null;

  return (
    <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered custom-modal-width">
        <div className="modal-content">
          <div className="modal-header pb-0" style={{ borderBottom: '0px' }}>
            <div>
              <h5 className="modal-title" style={{ fontSize: '19px' }}>{docType}  Fields</h5>
              <h6 style={{ fontSize: '13px', color: '#686666' }}>+ Add / Remove Fields</h6>
            </div>
            <button type="button" className="btn-close" style={{ fontSize: '13px', position: "relative", top: "-12px" }} onClick={onClose}></button>
          </div>

          <div className="modal-body p-0">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12 pt-4">
                  {isLoading ? (
                    <p>Loading...</p>
                  ) : isError ? (
                    <p>Error loading fields</p>
                  ) : (
                    <div className="row scroll-container" id="scrollable-container">
                      {fields.map((field, index) => (
                        <div key={index} className="col-md-4 mb-2">
                          <div
                            className="d-flex align-items-center px-1"
                            style={{ cursor: 'pointer' }}
                            onClick={() => toggleFieldSelection(index)}
                          >
                            <input
                              type="checkbox"
                              className="form-check-input me-2"
                              checked={field.selected}
                              onChange={() => {}}
                            />
                            <span style={{ fontSize: '14px' }}>{field.name}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="modal-footer" style={{ borderTop: "0px" }}>
            <p className="createbtn m-0" onClick={handleSave}>
              Save
            </p>
          </div>
        </div>
      </div>

      {/* Custom styles */}
      <style>{`
        .custom-modal-width {
          max-width: 1100px;
          width: 100%;
        }
        .scroll-container {
          max-height: 350px;
          overflow-y: auto;
          padding-right: 5px;
        }
        #scrollable-container::-webkit-scrollbar {
          width: 8px;
        }
        #scrollable-container::-webkit-scrollbar-track {
          background: #f1f1f1;
        }
        #scrollable-container::-webkit-scrollbar-thumb {
          background: orange;
          border-radius: 4px;
        }
        #scrollable-container::-webkit-scrollbar-thumb:hover {
          background: #e07b00;
        }
      `}</style>
    </div>
  );
};

export default ConfigureColumns;
